<main class="s-siteContainer">

  <section class="c-hero">
    <div class="l-container">
      <div class="l-grid">
        <div class="l-col lg:6 sm:12">
          <div class="c-hero__body">
            <h1 class="c-hero__title" translate>Edukacijski centri za kvalitetniju medicinsku izobrazbu</h1>
            <div class="c-hero__cta" *ngIf="!user && user !== undefined">
              <a [routerLink]="['/login']" class="c-btn is-primary is-outlined" translate>Prijavite se</a>
              <a [routerLink]="['/registration']" class="c-btn is-primary" translate>Registrirajte se</a>
            </div>
          </div>
        </div>
        <div app-hero-image class="l-col lg:6 sm:12"></div>
      </div>
    </div>
  </section>

  <div class="c-media__placeholder l-grid l-grid--40 is-3:1 is-loading" *ngIf="loading"></div>

  <div class="s-section" *ngIf="!loading">
    <div class="l-container">
      <div class="l-grid l-grid--40">

        <div class="l-col lg:6 sm:6 xs:12" *ngFor="let center of centers">
          <article app-card class="c-card" [title]="center.name"
                   [imageUrl]="center.banner_image | file:'image':'local'"
                   [tags]="[{name: coursesCount(center)}]"
                   [link]="['/courses/centers', center.short_name]"></article>
        </div>

      </div>
    </div>
  </div>
</main>

<app-subscription-form *ngIf="!user"></app-subscription-form>
